import { CreateExternalNoteDocument, MeetingDetailPageDocument } from 'generated/resources/graphql'

import DropZone from 'modules/core/components/DropZone'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  meetingId: number
}

export function UploadTranscript({ meetingId }: Props) {
  const { access } = useCurrentSession()
  const [createExternalNote, {}] = useMutation(CreateExternalNoteDocument, {
    extractorFn: (data) => data.oneOnOnesMutations.createFromTextOneononesExternalNote,
  })
  return (
    <DropZone
      accept={acceptedContentTypes(['text/plain'])}
      onDrop={(files) => {
        if (files[0]) {
          const file = files[0]
          file
            .text()
            .then(async (text) => {
              const response = await createExternalNote({
                variables: {
                  meetingId: meetingId,
                  fileName: file.name,
                  text,
                  uploaderAccessId: access.id,
                },
                refetchQueries: [MeetingDetailPageDocument],
              })

              const result = handleResult(response, () => {
                // TODO: do something with form errors
              })

              if (result.success) {
                track(trackingEvents.one_on_ones.addOneToOneTranscript)
              }
            })
            .catch(() => {
              app.setFlash({
                type: 'wrong',
                message: i18n.t('one_on_ones.meeting.transcript.upload.error'),
              })
            })
        }
      }}
    />
  )
}
